import { Module } from 'vuex';
import any = jasmine.any;

export interface discoveryReviewStore {
  documentContent: [];
  countSelectedItems: number;
  countSelectedGroupItems: number;
  documentActivatedBookmark: any;
  removeDocumentBookmarked: string;
  dataTag: string;
  scrollPositionListCollection: number;
}
export const discoveryReview: Module<discoveryReviewStore, any> = {
  namespaced: true,
  state: {
    documentContent: [],
    countSelectedItems: 0,
    countSelectedGroupItems: 0,
    documentActivatedBookmark: {},
    removeDocumentBookmarked: '',
    dataTag: '',
    scrollPositionListCollection: 0,
  },

  getters: {
    getDocumentContent: state => state.documentContent,
    getCountSelectedItems: state => state.countSelectedItems,
    getCountSelectedGroupItems: state => state.countSelectedGroupItems,
    getDocumentActivatedBookmark: state => state.documentActivatedBookmark,
    getRemoveDocumentBookmarked: state => state.removeDocumentBookmarked,
    getDataTag: state => state.dataTag,
    getScrollPositionListCollection: state => state.scrollPositionListCollection,
  },

  mutations: {
    setDocumentContent(state, documentContent) {
      state.documentContent = documentContent;
    },
    setCountSelectedItems(state, countSelectedItems) {
      state.countSelectedItems = countSelectedItems;
    },
    setCountSelectedGroupItems(state, countSelectedGroupItems) {
      state.countSelectedGroupItems = countSelectedGroupItems;
    },
    setDocumentActivatedBookmark(state, documentActivatedBookmark) {
      state.documentActivatedBookmark = documentActivatedBookmark;
    },
    setRemoveDocumentBookmarked(state, removeDocumentBookmarked) {
      state.removeDocumentBookmarked = removeDocumentBookmarked;
    },
    setDataTag(state, dataTag) {
      state.dataTag = dataTag;
    },
    setScrollPositionListCollection(state, scrollPositionListCollection) {
      state.scrollPositionListCollection = scrollPositionListCollection;
    },
  },

  actions: {
    changeDocumentContent(context, payload: { documentContent: [] }) {
      context.commit('setDocumentContent', payload.documentContent);
    },
    changeCountSelectedItems(context, payload: { countSelectedItems: number }) {
      context.commit('setCountSelectedItems', payload.countSelectedItems);
    },
    changeCountSelectedGroupItems(context, payload: { countSelectedGroupItems: number }) {
      context.commit('setCountSelectedGroupItems', payload.countSelectedGroupItems);
    },
    changeDocumentActivatedBookmark(context, payload: { documentActivatedBookmark: any }) {
      context.commit('setDocumentActivatedBookmark', payload.documentActivatedBookmark);
    },
    changeRemoveActionBookmarked(context, payload: { removeDocumentBookmarked: '' }) {
      context.commit('setRemoveDocumentBookmarked', payload.removeDocumentBookmarked);
    },
    changeDataTag(context, payload: { dataTag: '' }) {
      context.commit('setDataTag', payload.dataTag);
    },
    changeScrollPositionListCollection(context, payload: { scrollPositionListCollection: number }) {
      context.commit('setScrollPositionListCollection', payload.scrollPositionListCollection);
    },
  },
};
